import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/cte/ciot`

export const urlCiots = BASE_URL

export const urlDadosDeclaracaoCiot = `${BASE_URL}/dados-declaracao`

export const urlCiotsDisponiveis = `${BASE_URL}/disponiveis`

export const urlPisoMinimoCiot = `${BASE_URL}/piso-minimo`

export const urlGerarCiot = `${BASE_URL}/gerar`

export function urlCiot(id) {
  return `${BASE_URL}/${id}`
}

export function urlAcaoCiot(id, acao) {
  return `${BASE_URL}/${id}/${acao}`
}
